import userManagementsModule from "./user-managements";
import displaySettingsModule from "./display-settings";
import maintenanceModule from "./maintenance";
import platformSettingsModule from "./platform-settings";
import systemStatusModule from "./system-status";
import marketingPromoModule from "./marketing-promo";
import termConditionsModule from "./term-conditions";
import systemAcceptBetsModule from "./system-accept-bets";
import bonusBetTokenSymbolModule from "./bonus-bet-token-symbol";
import betPlacedAlertConfigModule from "./bet-placed-alert-config";
import stakeBonusThresholdModule from "./stake-bonus-threshold";

const settingsModule = {
  namespaced: true,
  modules: {
    "user-managements": userManagementsModule,
    "display-settings": displaySettingsModule,
    "maintenance": maintenanceModule,
    "platform-settings": platformSettingsModule,
    "system-status": systemStatusModule,
    "marketing-promo": marketingPromoModule,
    "term-conditions": termConditionsModule,
    "system-accept-bets": systemAcceptBetsModule,
    "bonus-bet-token-symbol": bonusBetTokenSymbolModule,
    "bet-placed-alert-config": betPlacedAlertConfigModule,
    "stake-bonus-threshold": stakeBonusThresholdModule,
  },
};

export default settingsModule;
